import React, { useState, useEffect } from "react";
import Slider from "react-slick";
import { NavLink } from "react-router-dom";

const hpMainSlider = {
    dots: false,
    autoplay: true,
    infinite: true,
    arrows: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1
  };


const Beauty_Grooming1 = () => {
    return (
        <>
        <div id="maincarousel" >
        <div className="container">
          <div className="row">
                              <div className="col-lg-3">
                              <div class="sc-gWXbKe hoZTIr __pf" id="__pf">
                              <div data-pf-type="Block" className="sc-bilyIR cCHonK pf-16_">
                    <h3 data-pf-type="Heading" className="sc-ctqQKy ioCblW pf-17_">
                      <i className="sc-gIDmLj huzWMp pf-18_ pfa pfa-bars" data-pf-type="Icon" />
                     
                        <NavLink 
                            to={'/search/beauty'}
                            exact
                            style={{color:'#fff'}}
                          >
                             <div data-pf-type="Image" className="sc-evcjhq RvYYJ pf-31_">
                        <img
                          src="https://static-sellercentral.shopperr.in/images/supplier/6049a93d223709632c7962b2/2022/71/1659602538656f8CrQ0.png"
                          srcSet="https://static-sellercentral.shopperr.in/images/supplier/6049a93d223709632c7962b2/2022/71/1659602538656f8CrQ0.png 1536w"
                        />
                      </div>
                        <span data-pf-type="Text" className="sc-jtXEFf kGfXVs pf-19_">
                        Beauty Grooming
                        </span>
                        </NavLink>
                    </h3>
                    <div className="sc-bilyIR cCHonK pf-20_">
                    <NavLink 
                            to={'/search/bath-body'}
                            exact
                          >
                    
                      <div data-pf-type="Image" className="sc-evcjhq RvYYJ pf-21_">
                        <img
                          src="https://static-sellercentral.shopperr.in/images/supplier/6049a93d223709632c7962b2/2022/71/1659602423624caxFZk.png"
                          srcSet="https://static-sellercentral.shopperr.in/images/supplier/6049a93d223709632c7962b2/2022/71/1659602423624caxFZk.png 1536w"
                        />
                      </div>
                      <h3 data-pf-type="Heading" className="sc-ctqQKy ioCblW pf-22_">
                        <span data-pf-type="Text" className="sc-jtXEFf kGfXVs pf-24_">
                        Bath & Body
                        </span>
                      </h3>
                      </NavLink>
                      </div>
                    <div className="sc-bilyIR cCHonK pf-25_"
                    >
                      <NavLink 
                            to={'/search/hair-care-styling'}
                            exact
                          >
                      <div data-pf-type="Image" className="sc-evcjhq RvYYJ pf-26_">
                        <img
                          src="https://static-sellercentral.shopperr.in/images/supplier/6049a93d223709632c7962b2/2022/71/1659602479504c3wc7r.png"
                          srcSet="https://static-sellercentral.shopperr.in/images/supplier/6049a93d223709632c7962b2/2022/71/1659602479504c3wc7r.png 1536w"
                        />
                      </div>
                      <h3 data-pf-type="Heading" className="sc-ctqQKy ioCblW pf-27_">
                        <span data-pf-type="Text" className="sc-jtXEFf kGfXVs pf-29_">
                        Hair Care & Styling
                        </span>
                      </h3>
                      </NavLink>
                    </div>
                    
                    <div
                      
                      className="sc-bilyIR cCHonK pf-30_"
                    >
                      <NavLink 
                            to={'/search/make-up-nails'}
                            exact
                          >
                      <div data-pf-type="Image" className="sc-evcjhq RvYYJ pf-31_">
                        <img
                          src="https://static-sellercentral.shopperr.in/images/supplier/6049a93d223709632c7962b2/2022/71/1659602538656f8CrQ0.png"
                          srcSet="https://static-sellercentral.shopperr.in/images/supplier/6049a93d223709632c7962b2/2022/71/1659602538656f8CrQ0.png 1536w"
                        />
                      </div>
                      <h3 data-pf-type="Heading" className="sc-ctqQKy ioCblW pf-32_">
                        <span data-pf-type="Text" className="sc-jtXEFf kGfXVs pf-34_">
                        Make Up & Nails
                        </span>
                      </h3>
                      </NavLink>
                    </div>
                    <div
                      
                      className="sc-bilyIR cCHonK pf-35_"
                    >
                      <NavLink 
                            to={'/search/skin-care'}
                            exact
                          >
                      <div data-pf-type="Image" className="sc-evcjhq RvYYJ pf-36_">
                        <img
                          src="	https://static-sellercentral.shopperr.in/images/supplier/6049a93d223709632c7962b2/2022/71/1659602611600LfBxEY.png"
                          srcSet="	https://static-sellercentral.shopperr.in/images/supplier/6049a93d223709632c7962b2/2022/71/1659602611600LfBxEY.png 1536w"
                        />
                      </div>
                      <h3 data-pf-type="Heading" className="sc-ctqQKy ioCblW pf-37_">
                        <span data-pf-type="Text" className="sc-jtXEFf kGfXVs pf-39_">
                        Skin Care
                        </span>
                      </h3>
                      </NavLink>
                    </div>
                    <div
                      
                      className="sc-bilyIR cCHonK pf-40_"
                    >
                      <NavLink 
                            to={'/search/tools-accessories'}
                            exact
                          >
                      <div data-pf-type="Image" className="sc-evcjhq RvYYJ pf-41_">
                        <img
                          src="https://static-sellercentral.shopperr.in/images/supplier/6049a93d223709632c7962b2/2022/71/1659602677561qJjJmk.png"
                          srcSet="https://static-sellercentral.shopperr.in/images/supplier/6049a93d223709632c7962b2/2022/71/1659602677561qJjJmk.png 1536w"
                        />
                      </div>
                      <h3 data-pf-type="Heading" className="sc-ctqQKy ioCblW pf-42_">
                        <span data-pf-type="Text" className="sc-jtXEFf kGfXVs pf-44_">
                        Tools & Accessories
                        </span>
                      </h3>
                      </NavLink>
                    </div>
                    <div
                      
                      className="sc-bilyIR cCHonK pf-45_"
                    >
                      <NavLink 
                            to={'/search/tattoo-accessories'}
                            exact
                          >
                      <div data-pf-type="Image" className="sc-evcjhq RvYYJ pf-46_">
                        <img
                          src="https://static-sellercentral.shopperr.in/images/supplier/6049a93d223709632c7962b2/2022/71/1659602835521qqFDaq.png"
                          srcSet="https://static-sellercentral.shopperr.in/images/supplier/6049a93d223709632c7962b2/2022/71/1659602835521qqFDaq.png 1536w"
                        />
                      </div>
                      <h3 data-pf-type="Heading" className="sc-ctqQKy ioCblW pf-47_">
                        <span data-pf-type="Text" className="sc-jtXEFf kGfXVs pf-49_">
                        Tattoo Accessories
                        </span>
                      </h3>
                      </NavLink>
                    </div>
                  </div>
                  </div>
                              </div>
            <div className="col-lg-9"> <Slider {...hpMainSlider}>
            <div className="item">
                <a href="/search/skin-care" className="banner"><img src="https://static-sellercentral.shopperr.in/images/supplier/6049a93d223709632c7962b2/2022/61/1658915504795m1zUj0.png" style={{width: '100%'}} className='image_banner' alt="首页面（新）" /></a>
            </div>
            <div className="item">
                <a href="/search/tools-accessories" className="banner"><img src="https://static-sellercentral.shopperr.in/images/supplier/6049a93d223709632c7962b2/2022/61/1658915504781sdc0It.png" style={{width: '100%' }} className='image_banner' alt="Modern L-Shaped Sofa Price" /></a>
            </div>
            {/* <div className="item">
                <a href="/products/sofa" className="banner"><img src="https://static-sellercentral.shopperr.in/images/supplier/6049a93d223709632c7962b2/2022/61/1657711628171PZ80nC.png" style={{width: '100%'}} alt="Sofa S1015" /></a>
            </div> */}
            
            
            
        </Slider></div>
          </div>
        </div>
        <div className='container' style={{marginTop:'20px'}}>
            <div className='row sc-gWXbKe hoZTIr __pf' id="__pf">
                <div className='col-lg-6'>
                <a href="/search/hair-care-styling">
                <div data-pf-type="Column" className="sc-hAcGzb bAQARH pf-571_">
                <h3 data-pf-type="Heading" className="sc-ctqQKy ioCblW pf-58_">
                <span data-pf-type="Text" className="sc-jtXEFf kGfXVs pf-60_"><br />
                <span style={{'font-weight': 'bold'}}></span>
                <br />

                </span>
                </h3>
                </div> 
                </a>
                </div>
                <div className='col-lg-6 ' >
                <a href="/search/make-up-pouches">
                <div data-pf-type="Column" className="sc-hAcGzb bAQARH pf-611_">
                    <h3 data-pf-type="Heading" className="sc-ctqQKy ioCblW pf-62_">
                        <span data-pf-type="Text" className="sc-jtXEFf kGfXVs pf-64_">
                        
                        <br />
                        <span style={{ fontWeight: 700 }}></span>
                        <br />
                        </span>
                    </h3>
                    </div>
</a>
                </div>
            </div>
        </div>
       
        </div>
        </>

    )
}

export default Beauty_Grooming1;
